import { Inject, Injectable } from '@angular/core';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { ReadResult } from '../../models/net/result/crud/read-result';
import { HttpFactory } from '../../utilities/http-factory';

@Injectable({
    providedIn: 'root'
})

export class ProductService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "product");
    }

    public anonSearch<TRequest, TResult>(request: TRequest): Observable<TResult[] | null>  {

        const result = HttpFactory.anonPost<any>(this.http, request, this._controllerName + "/searchanonymous", this._apiBaseUrl);

        return result;
    }
}
